import { getServerUrl } from "./serverUrls";
const version = "v63/";
export const apiURL = process.env.REACT_APP_API_URL + "api/";
export const baseURL = apiURL + version;
export const serverUrl = getServerUrl();
